import React from 'react';

import { institutionLoginsSelectors } from 'app-components/flux/institution-logins';

import OpenInNewIcon from '@mui/icons-material/OpenInNewRounded';
import type { BoxProps } from '@mui/material/Box';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import Dump from 'components/Dump';
import InstitutionIcon from 'components/InstitutionIcon';
import { useAppSelector } from 'hooks/redux';

export type InstitutionItemProps = BoxProps & {
  value?: string | null; // institution login id
  title?: string | null;
};
const InstitutionItem = ({ value, title, ...otherProps }: InstitutionItemProps) => {
  const institutionLogin = useAppSelector((state) =>
    institutionLoginsSelectors.getInstitutionLoginForId(state, value || ''),
  );
  const institution = useAppSelector((state) =>
    institutionLoginsSelectors.getInstitutionForInstitutionLogin(state, value || ''),
  );
  return (
    <Box display='flex' alignItems='center' gap={2} sharedcomponentid={InstitutionItem.name} {...otherProps}>
      <InstitutionIcon institution={institution} size='sm' />
      <Box flex={1}>
        <Typography variant='titleMedium' style={{ whiteSpace: 'nowrap' }}>
          {title || institutionLogin?.name || institution?.name}
        </Typography>

        {institution?.url && (
          <Link
            href={institution?.url}
            target='_blank'
            underline='hover'
            variant='captionRegular'
            color='textSecondary'
          >
            {institution?.url}
            &nbsp;
            <OpenInNewIcon fontSize='inherit' />
          </Link>
        )}
        <Dump obj={institution} />
      </Box>
    </Box>
  );
};
export default InstitutionItem;
